import React from 'react';
import classNames from 'classnames';

import zoomIcon from './assets/zoom-2-copy.svg';
import {ErrorField} from 'components/Fields';
import Search from 'components/Search';

import './styles.css';

const SearchField = ({
  input: {onChange, onBlur, value},
  options,
  placeholder,
  className,
  meta: {touched, error},
  onInputKeyDown,
  onInputChange,
  isLoading,
  disabled,
  searchable,
  filterOptions
}: any) => {
  return (
    <div className="SearchField">
      <div
        className="inputWrapper"
        style={{backgroundImage: 'url(' + zoomIcon + ')'}}>
        <Search
          className={classNames(
            {error: touched && error},
            {disabled},
            className
          )}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          options={options}
          onInputKeyDown={onInputKeyDown}
          isLoading={isLoading}
          onInputChange={onInputChange}
          disabled={disabled}
          filterOptions={filterOptions}
          searchable={searchable}
        />
      </div>
      <ErrorField touched={touched} error={error} className="errorField" />
    </div>
  );
};

export default SearchField;
